<template>
  <el-dialog title="限时审批" :visible.sync="visible" width="552px" :append-to-body="true" center>
    <div class="fix-form">
      <el-radio-group v-model="timeLimitedApproval.timeoutAction" class="check-group">
        <el-radio label="autoApprove"><span class="name-text">超过
          <el-select v-model="time1" placeholder="请选择" size="mini" class="time-select">
            <el-option
              v-for="item in timeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>小时未处理，系统自动设置审批人通过</span></el-radio>
        <el-radio label="autoReject"><span class="name-text">超过
          <el-select v-model="time2" placeholder="请选择" size="mini" class="time-select">
            <el-option
              v-for="item in timeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>小时未处理，系统自动设置审批人拒绝</span></el-radio>
      </el-radio-group>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  name: "timeLimited",
  components: {},
  data() {
    return {
      visible: false,
      time1:'24',
      time2:'24',
      timeList:[
        {value:'24',label:'24'},
        {value:'48',label:'48'},
        {value:'72',label:'72'},
      ],
      timeLimitedApproval:{...this.$store.state.design.settings.timeLimitedApproval}
    }
  },
  methods: {
    show() {
      this.visible = true
      this.timeLimitedApproval = this.$deepCopy(this.$store.state.design.settings.timeLimitedApproval)
      if(this.timeLimitedApproval.timeoutAction=='autoApprove'){
        this.time1 = this.timeLimitedApproval.timeoutHours
      }else if(this.timeLimitedApproval.timeoutAction=='autoReject'){
        this.time2 = this.timeLimitedApproval.timeoutHours

      }
    },
    save() {
      // this.visible = false
      // let value = {
      //   enable:true,
      //   ...this.timeLimitedApproval.sameApproverMultipleTimes
      // }
      let data1 = {
        key:'timeoutAction',
        value:this.timeLimitedApproval.timeoutAction
      }
      this.$store.commit("updateProTimeLimited",data1);
      let data2 = {
        key:'timeoutHours',
        value:this.timeLimitedApproval.timeoutAction=='autoApprove'?this.time1:this.time2
      }
      this.$store.commit("updateProTimeLimited",data2);
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog--center .el-dialog__body{
  padding: 10px 32px 0;
}
.fix-form{
  .time-select{
    Width: 60px;
    margin: 0 6px;
    /deep/.el-input__inner{
      padding-left:10px
    }
  }
  /deep/.check-group{
    margin-bottom: 10px;
  }
  /deep/.el-radio{
    display: block;
    line-height: 40px;
    .name-text{
      color: #606266;
    }
  }
}
</style>
